/* Collection tiles: load the second product image on hover of the photo only.
   Touch uses a first tap to reveal that image, then a second tap to open the product. */
(function () {
  if (window.__motCollectionHoverImage) return;
  window.__motCollectionHoverImage = true;

  var root = document.getElementById('collection');
  if (!root) return;

  var fineHover = false;
  try {
    fineHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  } catch (e) {}

  var lastPointer = 'mouse';

  function ensureHoverImage(link) {
    if (!link || link.getAttribute('data-hover-ready') === '1') return;
    var src = link.getAttribute('data-hover-src');
    if (!src) return;
    link.setAttribute('data-hover-ready', '1');

    var img = document.createElement('img');
    img.className = 'product-tile-hover';
    img.alt = '';
    img.decoding = 'async';
    img.setAttribute('fetchpriority', 'low');
    img.addEventListener('load', function () {
      img.classList.add('is-loaded');
    });
    img.src = src;
    link.appendChild(img);
  }

  function imageLinkFrom(target) {
    if (!target || !target.closest) return null;
    var link = target.closest('a.has-hover-image');
    if (!link || !link.closest('.il-preview')) return null;
    return link;
  }

  root.addEventListener('pointerdown', function (event) {
    lastPointer = event.pointerType || 'mouse';
  }, true);

  root.addEventListener('pointerenter', function (event) {
    if (!fineHover || lastPointer === 'touch') return;
    var link = imageLinkFrom(event.target);
    if (link) ensureHoverImage(link);
  }, true);

  root.addEventListener('focusin', function (event) {
    var link = imageLinkFrom(event.target);
    if (link) ensureHoverImage(link);
  });

  root.addEventListener('click', function (event) {
    if (lastPointer !== 'touch') return;
    var link = imageLinkFrom(event.target);
    if (!link || !link.getAttribute('data-hover-src')) return;
    if (link.classList.contains('is-swapped')) return;
    event.preventDefault();
    event.stopPropagation();
    var open = root.querySelectorAll('a.has-hover-image.is-swapped');
    for (var i = 0; i < open.length; i++) open[i].classList.remove('is-swapped');
    ensureHoverImage(link);
    link.classList.add('is-swapped');
  }, true);
})();
